import FallbackMarker from "./FallbackMarker"

import styles from "./IconCell.module.less"

/**
 * The Icon column always renders something — there is no empty cell.
 *
 * The fallback marker sits in the *same* container as a real icon: same size, same border, same
 * background. With several hundred values and a long tail, most rows show the marker at any given
 * time, so a visually different "broken-looking" cell would make the page's normal state look like
 * a defect. The marker carries no tooltip and no call to action of its own; acting on missing icons
 * is done through the No icon filter.
 */
const IconCell = ({ iconUrl, rawValue }) => (
  <div className={styles.container}>
    {iconUrl ? <img className={styles.icon} src={iconUrl} alt={rawValue} /> : <FallbackMarker />}
  </div>
)

export default IconCell
